import { Chip, Tooltip } from '@mui/joy';

import {
    CAMPAIGN_STATUS_COLORS, CAMPAIGN_STATUS_LABELS,
    MODERATION_STATUS_COLORS, MODERATION_STATUS_LABELS,
    SYSTEM_PAUSE_LABELS,
} from './adsConstants';


/**
 * Чип статуса кампании или креатива.
 *
 * Для системной остановки показываем причину в подсказке: партнёр должен
 * понимать, он сам остановил кампанию или это сделала система из-за денег.
 */
export default function AdStatusChip({
    status, kind = 'campaign', systemPaused, systemPauseReason, size = 'sm',
}) {
    const labels = kind === 'campaign' ? CAMPAIGN_STATUS_LABELS : MODERATION_STATUS_LABELS;
    const colors = kind === 'campaign' ? CAMPAIGN_STATUS_COLORS : MODERATION_STATUS_COLORS;

    const label = labels[status] || status;
    const color = colors[status] || 'neutral';

    const chip = (
        <Chip size={size} variant="soft" color={color} sx={{ fontWeight: 600 }}>
            {label}
        </Chip>
    );

    if (systemPaused && systemPauseReason) {
        return (
            <Tooltip
                arrow
                variant="soft"
                title={SYSTEM_PAUSE_LABELS[systemPauseReason] || systemPauseReason}
            >
                {chip}
            </Tooltip>
        );
    }
    return chip;
}